///
/// EarthBrowser
///
/// Created by Matt Giger on 9/18/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Original dropped files, keyed by dataset window id. The file-drop
/// handlers parse into in-memory providers and discard the File; cloud
/// upload needs the original bytes, so eligible handlers park the File
/// here (session-lifetime, like DataProviderRegistry).
///

import type { UserDatasetFormat } from "@shared-types"

export interface DatasetSourceFile {
	file: File
	format: UserDatasetFormat
	featureCount?: number
}

const sources = new Map<string, DatasetSourceFile>()

export function registerDatasetSourceFile(windowId: string, source: DatasetSourceFile): void {
	sources.set(windowId, source)
}

export function getDatasetSourceFile(windowId: string): DatasetSourceFile | undefined {
	return sources.get(windowId)
}
